/* eslint-disable react/prop-types */
/* eslint-ignore */
// @ts-nocheck
import React, { useEffect } from 'react';

import useComponentVisible from 'hooks/useComponentVisible';

const DropdownWrapper = ({ hideDropdown, children }) => {
  const { ref, isComponentVisible } = useComponentVisible(true);
  useEffect(() => {
    if (!isComponentVisible) hideDropdown();
  }, [isComponentVisible, hideDropdown]);
  return <div ref={ref}>{isComponentVisible && children}</div>;
};

export default DropdownWrapper;
